module.exports = __webpack_public_path__ + "static/media/AshevilleBrewingplanetmuralinprogress.3b9845da.webp";